import React from "react";

const LayoutSkeleton = () => {
    return (
        <div className="bg-gray-900 min-h-screen text-white">
            {/* Top Header Skeleton */}
            <header className="bg-gray-800 border-b border-gray-700 px-4 py-3 fixed top-0 left-0 right-0 lg:left-64 z-50">
                <div className="flex items-center justify-between">
                    {/* Logo Skeleton */}
                    <div className="flex items-center space-x-2">
                        <div className="w-8 h-8 bg-gray-700 rounded-full animate-pulse"></div>
                        <div className="h-6 w-32 bg-gray-700 rounded animate-pulse"></div>
                    </div>

                    {/* Right Side Icons Skeleton */}
                    <div className="flex items-center space-x-4">
                        <div className="w-10 h-10 bg-gray-700 rounded-lg animate-pulse"></div>
                        <div className="w-10 h-10 bg-gray-700 rounded-lg animate-pulse"></div>
                    </div>
                </div>
            </header>

            {/* Desktop Sidebar Skeleton */}
            <aside className="hidden lg:block w-64 bg-gray-800 border-r border-gray-700 fixed left-0 top-0 bottom-0 z-40">
                {/* Sidebar Header Skeleton */}
                <div className="p-6 border-b border-gray-700">
                    <div className="flex items-center space-x-3">
                        <div className="w-12 h-12 bg-gray-700 rounded-full animate-pulse"></div>
                        <div className="flex-1">
                            <div className="h-4 w-32 bg-gray-700 rounded animate-pulse mb-2"></div>
                            <div className="h-3 w-20 bg-gray-700 rounded animate-pulse"></div>
                        </div>
                    </div>
                </div>

                {/* Desktop Navigation Menu Skeleton */}
                <nav className="p-4 space-y-2">
                    {[...Array(6)].map((_, index) => (
                        <div key={index} className="flex items-center space-x-3 p-3 rounded-lg bg-gray-700 animate-pulse">
                            <div className="w-6 h-6 bg-gray-600 rounded animate-pulse"></div>
                            <div className="h-4 w-24 bg-gray-600 rounded animate-pulse"></div>
                        </div>
                    ))}
                </nav>
            </aside>

            {/* Main Content Skeleton */}
            <main className="lg:ml-64 mt-16 min-h-screen">
                <div className="p-4 pb-20 lg:pb-6">
                    <div className="bg-gray-800 rounded-lg p-4 lg:p-6 min-h-[calc(100vh-8rem)]">
                        {/* Generic Page Content Skeleton */}
                        <div className="space-y-6">
                            {/* Generic Page Header */}
                            <div className="mb-8">
                                <div className="h-10 w-48 bg-gray-700/50 rounded-xl animate-pulse mb-3"></div>
                                <div className="h-4 w-72 bg-gray-700/30 rounded-lg animate-pulse"></div>
                            </div>

                            {/* Generic Content Blocks */}
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                {[...Array(6)].map((_, index) => (
                                    <div key={index} className="bg-gray-700/30 border border-gray-700 rounded-2xl p-6 h-64 animate-pulse">
                                        <div className="flex items-center space-x-4 mb-4">
                                            <div className="w-12 h-12 bg-gray-600/50 rounded-xl"></div>
                                            <div className="flex-1 space-y-2">
                                                <div className="h-4 w-2/3 bg-gray-600/50 rounded"></div>
                                                <div className="h-3 w-1/2 bg-gray-600/30 rounded"></div>
                                            </div>
                                        </div>
                                        <div className="space-y-3">
                                            <div className="h-3 w-full bg-gray-600/20 rounded"></div>
                                            <div className="h-3 w-full bg-gray-600/20 rounded"></div>
                                            <div className="h-3 w-3/4 bg-gray-600/20 rounded"></div>
                                        </div>
                                        <div className="mt-8 h-10 w-full bg-gray-600/40 rounded-xl"></div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {/* Mobile Bottom Navigation Skeleton */}
            <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-gray-800 border-t border-gray-700 z-50">
                <div className="flex justify-around items-center p-3">
                    {[...Array(4)].map((_, index) => (
                        <div key={index} className="flex flex-col items-center space-y-1 p-2">
                            <div className="w-6 h-6 bg-gray-700 rounded animate-pulse"></div>
                            <div className="h-3 w-12 bg-gray-700 rounded animate-pulse"></div>
                        </div>
                    ))}
                </div>
            </nav>
        </div>
    );
};



export default LayoutSkeleton;